import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URL } from "config";
import { useAuth } from "AuthContext";
import { useMemo } from "react";

// MUI components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Custom components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import FormField from "layouts/pages/account/components/FormField";
import SoftSnackbar from "components/SoftSnackbar";

function AccountDetails({ value = {}, onChange, onUpdate, loading, setLoading }) {

  /* ================= PERMISSIONS ================= */
  const { permissions: ctxPerms = [] } = useAuth();

  const storedPerms = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]");
    } catch {
      return [];
    }
  }, []);

  const permSet = useMemo(() => {
    const perms = ctxPerms.length ? ctxPerms : storedPerms;
    return new Set(perms.map(p => (typeof p === "string" ? p : p.name)));
  }, [ctxPerms, storedPerms]);

  const canSection = permSet.has("UserProfile.AccountDetails");
  const canView = (key) => permSet.has(`UserProfile.AccountDetails.${key}`);

  const { id } = useParams();
  const [formData, setFormData] = useState({
    ...value
  });
 
  useEffect(() => {
    if (value) {
      setFormData({ ...value })
    }
  }, [value]);

  useEffect(() => {
    console.log("🧾 AccountDetails formData updated:", formData);
  }, [formData]);

  const handleChange = (field) => (e) => {
    const updated = { ...formData, [field]: e.target.value };
    setFormData(updated);
    onChange && onChange(updated);
  }



  if (!canSection) {
    return null;
  }

  return (
    <>
      <Card id="account-details">
        <SoftBox p={3}>
          <SoftTypography variant="h5">Account Details</SoftTypography>
        </SoftBox>
        <SoftBox component="form" pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              {canView("BankName") && (
                <FormField
                  label="Bank Name"
                  placeholder="Enter bank name"
                  value={formData.bank_name}
                  onChange={handleChange("bank_name")}

                />
              )}

            </Grid>
            <Grid item xs={12} sm={6}>
              {canView("BranchAddress") && (
                <FormField
                  label="Branch Name/Address"
                  placeholder="Enter branch name/address"
                  value={formData.branch_address}
                  onChange={handleChange("branch_address")}

                />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {canView("AccountNumber") && (
                <FormField
                  label="Account Number"
                  placeholder="Enter account number"
                  value={formData.account_number}
                  onChange={handleChange("account_number")}

            
                />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {canView("ConfirmAccountNumber") && (
                <FormField
                  label="Confirm Account Number"
                  placeholder="Re-enter account number"
                  value={formData.account_number_confirmation}
                  onChange={handleChange("account_number_confirmation")}

                // inputProps={{ 
                //   maxLength: 18,
                //   pattern: "[0-9]*",
                //   inputMode: "numeric"
                // }}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {canView("IFSC") && (
                <FormField
                  label="IFSC Code"
                  placeholder="Enter IFSC code (eg: ABCD0123456)"
                  value={formData.ifsc_code}
                  onChange={handleChange("ifsc_code")}
    
                />
            

              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {canView("UAN") && (
                <FormField
                  label="UAN NO."
                  placeholder="Enter UAN NO."
                  value={formData.uan_no}
                  onChange={handleChange("uan_no")}

                />
              )}

            </Grid>
            <Grid item xs={12} sm={6}>
              {canView("ESIC") && (
                <FormField
                  label="ESIC NO. "
                  placeholder="Enter ESIC NO. "
                  value={formData.esic_no}
                  onChange={handleChange("esic_no")}

                />
              )}
            </Grid>
          </Grid>

          <SoftBox mt={3} display="flex" justifyContent="flex-end">
            {canView("Save") && (
              <SoftButton
                disabled={loading || !value?.is_accountdetails}
                variant="gradient"
                color="info"
                onClick={() => {
                  console.log("📤 Submitting formData:", formData);

                  setLoading(false)
                  onUpdate()
                }}

              >

                {loading ? "Saving..." : "Save"}
              </SoftButton>
            )}
          </SoftBox>
        </SoftBox>
      </Card>

    </>
  );
}

AccountDetails.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
};

export default AccountDetails;
